function dm_a_04_timeline(){
    console.log(">> dm_a_04_timeline")
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.timeline').forEach(el => dm_a_04_timeline_init(el));
  });
}

function dm_a_04_timeline_init(root, opts = {}) {
  console.log(">> dm_a_04_timeline_init")
  if (!root || !root.querySelector) return;

  const viewport = root.querySelector('.tl-viewport');
  const track = root.querySelector('.tl-track');
  const slides = Array.from(track.querySelectorAll('.tl-slide'));
  // support multiple control sets (desktop + mobile)
  const btnPrevEls = Array.from(root.querySelectorAll('.tl-prev'));
  const btnNextEls = Array.from(root.querySelectorAll('.tl-next'));
  const onSlideClick = typeof opts.onSlideClick === 'function' ? opts.onSlideClick : () => {};
  const longDateEl = root.querySelector('.long-date-cont');
  const contentEl  = root.querySelector('.content-cont');

  let x = 0, minX = 0, maxX = 0, dragging = false, startX = 0, dragStartX = 0, lastX = 0, clickGuard = false;
  const CLICK_DRAG_TOL = 5;
  const STEP = 1;

  // Track the logical active slide (not tied to translateX)
  let currentIndex = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
  if (currentIndex === -1) currentIndex = 0;

  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

  function setX(val, immediate = false) {
    x = val;
    if (immediate) {
      track.style.transition = 'none';
      track.style.transform = `translate3d(${x}px,0,0)`;
    } else {
      // let CSS handle duration/easing
      track.style.transition = '';
      track.style.transform = `translate3d(${x}px,0,0)`;
    }
  }

  function updateButtons() {
    // Disable by logical index, not by x/maxX
    btnPrevEls.forEach(b => b.disabled = currentIndex <= 0);
    btnNextEls.forEach(b => b.disabled = currentIndex >= slides.length - 1);
  }

  function measure() {
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
    const trackWidth = slides.reduce((w, el, i) => w + el.offsetWidth + (i ? gap : 0), 0);
    const vpw = viewport.clientWidth;

    if (trackWidth <= vpw) {
      maxX = 0;
      setX(0, true);
    } else {
      maxX = -(trackWidth - vpw);
      x = clamp(x, maxX, minX);
      setX(x, true);
    }
    // ensure currentIndex in range and buttons reflect it
    currentIndex = clamp(currentIndex, 0, slides.length - 1);
    updateButtons();
  }

  // Helper: apply active state + staggered content swap with "changing" class
  function applyActive(idx) {
    slides.forEach(s => s.classList.remove('is-active'));
    const s = slides[idx];
    if (!s) return;
    s.classList.add('is-active');
    currentIndex = idx; // keep logical index in sync

    const dateEl       = s.querySelector('.date-long');
    const contentInner = s.querySelector('.content');
    const date_string    = dateEl ? dateEl.innerHTML : '';
    const content_string = contentInner ? contentInner.innerHTML : '';

    if (longDateEl) {
      setTimeout(() => { longDateEl.innerHTML = date_string; }, 200);
      setTimeout(() => { longDateEl.classList.remove('changing'); }, 450);
    }
    if (contentEl) {
      setTimeout(() => { contentEl.innerHTML = content_string; }, 400);
      setTimeout(() => { contentEl.classList.remove('changing'); }, 650);
    }
  }

  function slideStep(dir) {
    // Use logical index for navigation
    const targetIndex = clamp(currentIndex + (dir < 0 ? -STEP : STEP), 0, slides.length - 1);

    // Trigger side-content transition
    if (longDateEl) longDateEl.classList.add('changing');
    if (contentEl)  contentEl.classList.add('changing');

    // Update active slide/content
    applyActive(targetIndex);

    // Compute track offset for target slide; clamp to [maxX, 0]
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
    let acc = 0;
    for (let i = 0; i < targetIndex; i++) acc += slides[i].offsetWidth + (i ? gap : 0);
    const to = clamp(-acc, maxX, minX);

    setX(to);       // will not move if everything already fits (maxX === 0)
    updateButtons();
  }

  function preventDefault(e){ e.preventDefault(); }

  function onDown(e) {
    // ignore drags started on the prev/next controls so tapping them doesn't start a drag
    const tgt = (e.touches && e.touches[0] && e.touches[0].target) || e.target;
    if (tgt && tgt.closest && (tgt.closest('.tl-prev') || tgt.closest('.tl-next'))) {
      return;
    }

    const ptX = e.touches ? e.touches[0].clientX : e.clientX;
    dragging = true; clickGuard = false;
    startX = ptX; dragStartX = x; lastX = ptX;
    track.classList.add('dragging');
    track.style.transition = 'transform 0s';
    document.addEventListener('selectstart', preventDefault, { passive:false });
    window.addEventListener('mousemove', onMove, { passive:false });
    window.addEventListener('touchmove', onMove, { passive:false });
    window.addEventListener('mouseup', onUp, { passive:true });
    window.addEventListener('touchend', onUp, { passive:true });
  }
  function onMove(e) {
    if (!dragging) return;
    const ptX = e.touches ? e.touches[0].clientX : e.clientX;
    const dx = ptX - lastX; lastX = ptX;
    let next = x + dx;
    const atLeft = next > minX;
    const atRight = next < maxX;
    if (atLeft) next = minX + (next - minX) * 0.3;
    if (atRight) next = maxX + (next - maxX) * 0.3;
    setX(next, true);
    updateButtons();
    if (Math.abs(ptX - startX) > CLICK_DRAG_TOL) clickGuard = true;
    if (!e.touches) e.preventDefault();
  }
  function onUp() {
    if (!dragging) return;
    dragging = false;
    track.classList.remove('dragging');
    if (x > minX) setX(minX);
    if (x < maxX) setX(maxX);
    document.removeEventListener('selectstart', preventDefault);
    window.removeEventListener('mousemove', onMove);
    window.removeEventListener('touchmove', onMove);
    window.removeEventListener('mouseup', onUp);
    window.removeEventListener('touchend', onUp);
    updateButtons();
  }

  // Handlers stored so destroy() can remove them
  const onPrev = () => slideStep(-1);
  const onNext = () => slideStep(1);

  // Click a slide: same logic
  track.addEventListener('click', (e) => {
    const slide = e.target.closest('.tl-slide');
    if (!slide || clickGuard) return;
    const index = slides.indexOf(slide);
    if (index === -1) return;

    if (longDateEl) longDateEl.classList.add('changing');
    if (contentEl)  contentEl.classList.add('changing');

    applyActive(index);

    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
    let acc = 0; for (let i = 0; i < index; i++) acc += slides[i].offsetWidth + (i ? gap : 0);
    const to = clamp(-acc, maxX, minX);
    setX(to);
    updateButtons();

    onSlideClick(index, slide);
  });
  // attach handlers to all prev/next buttons (desktop + mobile sets)
  btnPrevEls.forEach(b => b.addEventListener('click', onPrev));
  btnNextEls.forEach(b => b.addEventListener('click', onNext));

  track.addEventListener('mousedown', onDown);
  track.addEventListener('touchstart', onDown, { passive:true });

  const ro = new ResizeObserver(measure);
  ro.observe(viewport);
  slides.forEach(s => ro.observe(s));
  window.addEventListener('load', measure);
  measure(); // initial sizing + button state by index
  // set initial active state/content from currentIndex
  applyActive(currentIndex);

  return {
    destroy() {
      ro.disconnect();
      window.removeEventListener('load', measure);
      // remove all handlers
      btnPrevEls.forEach(b => b.removeEventListener('click', onPrev));
      btnNextEls.forEach(b => b.removeEventListener('click', onNext));
      track.removeEventListener('mousedown', onDown);
      track.removeEventListener('touchstart', onDown);
      document.removeEventListener('selectstart', preventDefault);
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchend', onUp);
    }
  };
}

export { dm_a_04_timeline };
